<template>
  <div id="offline-replay" class="wrapper" v-loading="loading" element-loading-text="拼命加载中">
    <div class="courcetitle">
      <div class="classtitle">
        <i @click="goMyCourseDetail" class="fa-zhixin fa-mail-reply back-mine-icon"></i>
        {{title}}
      </div>
    </div>
    <div :style="{maxWidth: maxWidth + 'px'}" style="margin: 0 auto 50px;">
      <ali-player
        v-if="videoId && !noReplay"
        ref="player"
        :useEncrypt="true"
        :playAuth="playAuth"
        :source="null"
        :width="maxWidth"
        :height="maxHeight"
        :user-ratio="4 / 3"
        :video-id="videoId"
        :outCourse="false"></ali-player>
      <div v-show="noReplay" style="position: relative;padding-top: 75%;">
        <div class="cover">
          <div class="tips">回放视频处理中，暂时不能播放</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AliPlayer from '@/components/player/AliPlayer'
import { mapActions, mapState } from 'vuex'
import { LOGIN_TYPE } from '@/utils/constants'

const maxHeight = Math.min(window.innerHeight - 220, 768)

export default {
  name: 'OfflineVideo',
  data () {
    return {
      loading: true,
      classId: '',
      subId: '',
      goodsType: 5,
      videoId: '',
      playAuth: '',
      region: 'cn-shanghai',
      maxHeight: maxHeight,
      maxWidth: maxHeight / 0.75,
      noReplay: false,
      title: ''
    }
  },
  components: {
    'ali-player': AliPlayer
  },
  mounted () {
    this.classId = Number(this.$route.params.classId)
    this.subId = Number(this.$route.params.subId)
    this.init()
  },
  methods: {
    ...mapActions(['getUserInfo']),
    init () {
      if (this.isLogin === '') return
      if (this.isLogin === false) {
        this.$showLogin({ loginType: LOGIN_TYPE.LOGIN }, () => {
          this.getUserInfo().then(_ => {
            this.init()
          })
        })
      } else {
        this.getReplayInfo()
        this.getClassDetail()
      }
    },
    getClassDetail () {
      api.getClassDetail({ class_id: this.classId }).then(res => {
        if (res.data.code === 1) {
          const subsInfo = res.data.data.subs_info || []
          const subClass = subsInfo.filter(item => Number(item.subclass_id) === this.subId)[0]
          this.title = res.data.data.title + ' '
          if (JSON.stringify(subClass) !== '{}') {
            if (subClass.subject) {
              this.title += subClass.subject
            } else {
              this.title += `第${subClass.sub_index}节小课`
            }
          }
        }
      })
    },
    getReplayInfo () {
      api.getGatewayReplayInfo({
        subclass_id: this.subId,
        goods_type: this.goodsType
      }).then(res => {
        if (res.data.code === 1 && res.data.data.video_id) {
          this.initALiVideo(res.data.data)
        } else {
          this.handleError(res.data.message)
        }
      }).catch(() => {
        this.handleError()
      })
    },
    initALiVideo (data) {
      api.getOfflineVideoPlayAuth({
        video_id: data.video_id,
        subclass_id: this.subId,
        goods_type: this.goodsType
      }).then(res => {
        if (res.data.code === 1 && res.data.data.play_auth) {
          this.videoId = res.data.data.video_id
          this.playAuth = res.data.data.play_auth
          this.loading = false
          // 设置区域参数
          if (res.data.data.region) {
            this.region = res.data.data.region
          }
        } else {
          this.handleError()
        }
      }).catch(() => {
        this.handleError()
      })
    },
    goMyCourseDetail () {
      this.$router.push({ path: '/mycourse-detail/' + this.classId + '/offline' })
    },
    handleError (msg = '回放视频处理中，暂时不能播放') {
      this.loading = false
      this.noReplay = true
      this.$msgDialog(msg, () => {
        this.goMyCourseDetail()
      })
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  watch: {
    isLogin () {
      this.init()
    }
  }
}
</script>
<style lang="scss" scoped>
  #offline-replay {
    .cover {
      position: absolute;
      background: #52545a;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      .tips {
        position: absolute;
        top: 50%;
        margin-top: -50px;
        width: 100%;
        color: #fff;
        font-size: 20px;
        text-align: center;
      }
    }
    .courcetitle{
      background: white;
    }
    .classtitle {
      word-break: break-all;
      width: 1140px;
      height: 50px;
      line-height: 50px;
      margin: auto;
      font-size: 16px;
      i {
        cursor: pointer;
        padding: 17px 17px;
        margin-left: -22px;
        margin-right: -8px;
        vertical-align: baseline;
        color: rgba(0, 199, 191, 1);
      }
      @media (max-width: 767px) {
        padding-left: 20px;
        width: 100%;
        padding-right: 20px;
        display: flex;
        line-height: 25px;
      }
    }
    @media (max-width: 1023px) and (min-width: 376px) {
      .courcetitle .classtitle {
        width: 755px;
      }
    }
  }
</style>
<style>
  #offline-replay .prism-big-play-btn {
    margin-top: -32px !important;
    margin-left: -32px !important;
  }

  #offline-replay .prism-cover {
    background-repeat: no-repeat;
  }
</style>
